<template>
  <div id="app">
    <login></login>
    <menutop></menutop>
    <div class="container-fluid" id="dvconteudoapp">
      <router-view></router-view>
    </div>      
  </div>
</template>
<style>
  #dvconteudoapp{
    margin-top: 70px;
    padding: 0 0 15px 0;
    transition: padding-left 0.25s ease;
  }
  #dvcrud{
    margin-bottom: 15px;
  }
  #app{
    background-color: var(--draco-surface, white);
  }
  @media (min-width: 992px) {
    #dvconteudoapp{
      padding-left: 50px;
    }
    body.draco-sidenav-open #dvconteudoapp{
      padding-left: 250px;
    }
  }
  @media (max-width: 991px) {
    #dvconteudoapp{
      padding-left: 0;
    }
  }
</style>
<script>

import menutop from './views/menutop.vue'
import login from './views/login'


export default {
  name: 'app',
  components: {   
      'menutop' : menutop,
      'login'   : login
  },
  mounted:function(){    

  },
  methods:{
  },
  computed: {
  }
}
</script>
